import React from 'react';
import s from './s.module.less';
import Header from 'components/Header';
import { Email } from 'constants/contact';

const Page = () => {
    return (
        <div className={s.wrap}>
            <Header />
            <div className={s.content}>
                <div className={s.left}>
                    <h2>Frequently asked questions</h2>
                    <p className={s.p1}>Can’t find the answer you’re looking for? Reach out to our friendly team </p>
                    <p className={s.p2}><a href={`mailto:${Email.support}`}>{Email.support}</a></p>
                </div>
                <div className={s.right}>
                    <div className={s.item}>
                        <div className={s.itemTitle}>Lorem ipsum dolor sit amet, consectetur adipiscing?</div>
                        <div className={s.itemContent}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a,
                            mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus.
                            Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra,
                            per inceptos himenaeos. Praesent auctor purus luctus enim egestas, ac scelerisque ante pulvinar. Donec ut rhoncus ex.
                            Suspendisse ac rhoncus nisl, eu tempor urna. Curabitur vel bibendum lorem. Morbi convallis convallis diam sit amet lacinia.
                            Aliquam in elementum tellus.
                        </div>
                    </div>
                    <div className={s.item}>
                        <div className={s.itemTitle}>Lorem ipsum dolor sit amet, consectetur adipiscing?</div>
                        <div className={s.itemContent}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a,
                            mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus.
                            Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra,
                            per inceptos himenaeos. Praesent auctor purus luctus enim egestas, ac scelerisque ante pulvinar. Donec ut rhoncus ex.
                            Suspendisse ac rhoncus nisl, eu tempor urna. Curabitur vel bibendum lorem. Morbi convallis convallis diam sit amet lacinia.
                            Aliquam in elementum tellus.
                        </div>
                    </div>
                    <div className={s.item}>
                        <div className={s.itemTitle}>Lorem ipsum dolor sit amet, consectetur adipiscing?</div>
                        <div className={s.itemContent}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a,
                            mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus.
                            Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra,
                            per inceptos himenaeos. Praesent auctor purus luctus enim egestas, ac scelerisque ante pulvinar. Donec ut rhoncus ex.
                            Suspendisse ac rhoncus nisl, eu tempor urna. Curabitur vel bibendum lorem. Morbi convallis convallis diam sit amet lacinia.
                            Aliquam in elementum tellus.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Page;
